module.exports = __webpack_public_path__ + "static/img/yytx01.b8b8f53.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx01.png
// module id = 781
// module chunks = 0